import styled from "styled-components";

const StyledTabs = styled.div`

  /****************************/
  /*        Tab Menu          */
  /****************************/

  .tab_menu {
    border-bottom: .5rem solid rgba(0, 123, 255, 1.00);
  }

  @media screen and (max-width: 479px) {
    .tab_menu {
      border-bottom-width: 0.25rem;
    }
  }

  /****************************/
  /*        Tab List          */
  /****************************/

  .tab_list {
    display: flex;
    flex-direction: row;
    margin: 0;
    padding-left: 0;
    flex-direction: row;
    grid-column-gap: 1rem;
    grid-row-gap: 1rem;
    list-style-type: none;
  }

  @media screen and (max-width: 479px) {
    .tab_list {
      flex-direction: column;
      grid-column-gap: 0;
      grid-row-gap: 0;
    }
  }

  /****************************/
  /*        Tab Button        */
  /****************************/

  .tab_button {
    border: none;
    width: 100%;
  }

  .tab_button {
    padding: 1rem 30px;
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
    color: #fff;
    background-color: #007bff;
    text-decoration: none;
    text-align: left;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
  }

  @media (prefers-reduced-motion: reduce) {
    .tab_button {
      transition: none;
    }
  }

  button.tab_button:hover {
    background-color: rgba(0, 123, 255, .77);
  //  opacity: 0.77;
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
  }

  /* active */
  .tab_button.active {
    color: #fff;
    background-color: #007bff;
    text-decoration: none;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
  }

  /* not active */
  .tab_button:not(.active) {
    background-color: rgba(0, 123, 255, 0.35);
    color: rgba(255, 255, 255, 1.00);
  }

  .tab_icon {
    font-family: 'Font Awesome 6 Free', sans-serif;
    color: #000;
  }

  .tab_label {
    margin-left: .5rem;
  }
  
  .tab-font-size {
    font-size: 1.5rem;
  }

  {/* Mobile Portrait Only */}
  @media screen and (max-width: 479px) {
    .tab-font-size {
      font-size: calc(0.7rem + 2.0vw);
    }
  }

  /****************************/
  /*        Tab Pane          */
  /****************************/

  .tab_pane {
    display: block;
  }

  
  
  

  //.mt-0 {
  //  margin-top: 0 !important;
  //}
  .mx-2 {
    margin-left: 0.5rem !important;
  }

  .px-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }


  .slideIn-enter {
    opacity: 0;
    transform: translateX(-25%);
  }

  .slideIn-enter-active {
    opacity: 1;
    transform: translate(0);
    transition: opacity 0.15s linear, transform 0.3s ease-out;
  }

  .slideIn-exit {
    transform: translate(0);
  }

  .slideIn-exit-active {
    transform: translate(25%);
    transition: all 3.0s ease-out;
  } 

`

export default StyledTabs;